export enum AccessScope {
    Public = `public`,
    Cms = `cms`,
}
